import React from 'react';
import MuiCheckbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';
import IconCheckboxDefault from 'src/assets/icons/CheckboxDefault';
import IconCheckboxChecked from 'src/assets/icons/CheckboxChecked';
import { CheckboxIndeterminate } from 'src/assets/icons/CheckboxIndeterminate';

export const Checkbox = ({ iconClassName, ...props }) => {
  return (
    <MuiCheckbox
      icon={<IconCheckboxDefault className={iconClassName} />}
      checkedIcon={<IconCheckboxChecked className={iconClassName} />}
      indeterminateIcon={<CheckboxIndeterminate className={iconClassName} />}
      color="primary"
      {...props}
    />
  );
};

Checkbox.propTypes = {
  iconClassName: PropTypes.string,
};

Checkbox.defaultProps = {
  iconClassName: null,
};
